import { Button, Icon, MenuItem } from '@blueprintjs/core';
import { Select } from '@blueprintjs/select';
import AddressDetailTable from 'Components/Generic/Address/AddressDetailTable';
import GenericTableData from 'Data/GenericTableData';
import DataManager from 'Lib/DataManager';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import styles from './AddressSelect.module.css';

let DM = new DataManager();
let AddressData = GenericTableData.getTableDataBus('ADD', 'addresses');

const AddressSelect = ({
  addressIdList,
  onSelectAddress,
  defaultSelectedId,
  labelText = 'Select an Address...',
  required = false,
}) => {
  const [addressList, setAddressList] = useState([]);
  const [selectedItem, setSelectedItem] = useState();

  useEffect(() => {
    DM.add(
      AddressData.registerListener('RECORDS_LOADED', onAddressListLoaded),
      AddressData,
    );
    DM.add(
      AddressData.registerListener('RECORDS_LOAD_ERROR', onAddressListError),
      AddressData,
    );
  }, []);

  useEffect(() => {
    fetchAddresses();
  }, [addressIdList]);

  const fetchAddresses = () => {
    if (addressIdList?.length) {
      if (
        addressIdList.length !== addressList.length ||
        !addressList
          .map((adr) => adr.id)
          .every((id) => addressIdList.includes(id))
      ) {
        AddressData.getRecords(addressIdList, true);
      }
    } else {
      setAddressList([]);
    }
  };

  const onAddressListLoaded = (payload) => {
    if (payload) {
      setAddressList(payload);
    }
  };

  const onAddressListError = () => {};

  useEffect(() => {
    if (defaultSelectedId) {
      setSelectedItem(addressList.find((add) => add.id === defaultSelectedId));
    } else {
      setSelectedItem(null);
    }
  }, [defaultSelectedId, addressList]);

  const itemRenderer = (item, { handleClick, handleFocus, modifiers }) => {
    if (!item?.id) {
      return null;
    }
    if (!modifiers.matchesPredicate) {
      return null;
    }

    return (
      <MenuItem
        key={item.id}
        active={modifiers.active}
        onClick={handleClick}
        onFocus={handleFocus}
        // disabled={modifiers.disabled}
        text={
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 6,
              width: '100%',
              padding: 4,
            }}>
            <Icon icon={item === selectedItem ? 'tick' : 'blank'} />
            <AddressDetailTable
              addressObject={item}
              editable={false}
              compact
              includeBorder
            />
          </div>
        }
      />
    );
  };

  const onItemSelected = (item) => {
    setSelectedItem(item);
    onSelectAddress(item);
  };

  const clearButton = selectedItem ? (
    <Button
      minimal
      icon={'cross'}
      onClick={() => {
        onItemSelected(null);
      }}
    />
  ) : (
    addressIdList?.length > 0 && <Button minimal icon={'chevron-down'} />
  );

  const getSortedArray = () => {
    let sortedArray = [...addressList];
    if (addressList?.length && addressIdList?.length) {
      sortedArray = addressIdList.map((id) =>
        addressList.find((add) => add.id === id),
      );
    }
    return [
      ...sortedArray.filter((item) => item === selectedItem),
      ...sortedArray.filter((item) => item !== selectedItem),
    ];
  };

  return (
    <Select
      key={selectedItem?.id || 0}
      items={getSortedArray()}
      itemsEqual={'id'}
      filterable={false}
      onItemSelect={onItemSelected}
      popoverProps={{ minimal: true }}
      menuProps={{
        className: styles.menu_style,
      }}
      popoverContentProps={{
        className: styles.popover_content_style,
      }}
      itemRenderer={itemRenderer}
      noResults={<MenuItem disabled={true} text='No addresses.' />}
      intent={required ? 'danger' : ''}>
      <div
        className={`bp5-input${
          required && !selectedItem ? ' bp5-intent-danger' : ''
        }${!selectedItem ? ' bp5-text-muted' : ''}`}
        style={{
          display: 'flex',
          alignItems: 'center',
          paddingRight: 0,
        }}>
        <label
          className={
            !selectedItem ? (required ? styles.required : 'bp5-text-muted') : ''
          }
          style={{ flexGrow: 1, whiteSpace: 'nowrap', overflowX: 'hidden' }}>
          {selectedItem
            ? `${selectedItem.legal_name || ''}${
                selectedItem.legal_name && selectedItem.address_or_po_box_number
                  ? ' @ '
                  : ''
              }${selectedItem.address_or_po_box_number || ''}`
            : labelText || (required && '(Required)') || ''}
        </label>
        {clearButton}
      </div>
    </Select>
  );
};

AddressSelect.propTypes = {
  addressIdList: PropTypes.array,
  onSelectAddress: PropTypes.func,
  defaultSelectedId: PropTypes.number,
  labelText: PropTypes.string,
  required: PropTypes.bool,
};

export default AddressSelect;
